import React from 'react'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LabelAndValueUI from '../../../widgets/layout/LabelAndValueUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'

const RepaymentListOldUI = ({loan, repaymentList, totals, next, onRefreshClick}) =>
  <div>
    {
      !next &&
      <LRTableActionsUI location='top'
        left={
          <span className='g_flex_left g_flex_h'>
            <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
            <span className='g_m_left_100 g_large'><b>Last Repayments</b></span>
          </span>
        }
        right={<span />}
      />
    }
    {
      next &&
      <div className='g_m_left_100 g_m_top_200 g_large'><b>Next Repayments</b></div>
    }

    <table><tbody>
      <tr>
        <td className='g_text_center'><b className=''>Account</b></td>
        <td className='g_text_center'><b className='g_m_left_50 g_no_wrap'>Loan Type</b></td>
        <td className='g_text_center'><b className='g_m_left_50 g_no_wrap'>DSRA</b></td>
        <td className='g_text_center'><b className='g_m_left_50 g_no_wrap'>DSRA Cur</b></td>
        <td className='g_text_center'><b className='g_m_left_50 g_no_wrap'>EMI</b></td>
        <td className='g_text_center'><b className='g_m_left_50 g_no_wrap'>GST</b></td>
        <td className='g_text_center'><b className='g_m_left_50 g_no_wrap'>Late Int</b></td>
        <td className='g_text_center'><b className='g_m_left_50 g_no_wrap'>DSRA Int</b></td>
        <td className='g_text_center'><b className='g_m_left_50 g_no_wrap'>Default Int</b></td>
        <td className='g_text_center'><b className='g_m_left_50 g_no_wrap'>Payable</b></td>
        <td className='g_text_center'><b className='g_m_left_50 g_no_wrap'>Status</b></td>
      </tr>
      {
        repaymentList.map((repayment, i) =>
          <tr key={i}>
            <td><span className='g_no_wrap_2'>{repayment.accountName}</span></td>
            <td><span className='g_m_left_50'>{repayment.loanType}</span></td>
            <td className='g_text_right'><span className='g_m_left_50'>{repayment.dsraAmountF4}</span></td>
            <td className='g_text_right'><span className='g_m_left_50'>
              {repayment.dsraCurrentF4===repayment.dsraAmountF4 ? 'same' : repayment.dsraCurrentF4}
            </span></td>
            <td className='g_text_right'><span className='g_m_left_50'>{repayment.emiF4}</span></td>
            <td className='g_text_right g_m_left_50'>{repayment.gstF4}</td>
            <td className='g_text_right g_m_left_50'>{repayment.lateInterestF4}</td>
            <td className='g_text_right g_m_left_50'>{repayment.dsraDipInterestF4}</td>
            <td className='g_text_right g_m_left_50'>{repayment.defaultInterestF4}</td>
            <td className='g_text_right g_m_left_50'>{repayment.payableF4}</td>
            <td className='g_text_center'><span className='g_m_left_50'>{repayment.status}</span></td>
          </tr>
        )
      }
      <tr>
        <td><b>Total</b></td>
        <td></td>
        <td className='g_text_right'><span className='g_m_left_50'><b>{next ? totals.nextDSRAAmountF4 : totals.totalDSRAAmountF4}</b></span></td>
        <td className='g_text_right'><span className='g_m_left_50'><b>{next ? totals.nextDSRACurrentF4 : totals.totalDSRACurrentF4}</b></span></td>
        <td className='g_text_right'><span className='g_m_left_50'><b>{next ? totals.nextEMIF4 : totals.totalEMIF4}</b></span></td>
        <td className='g_text_right'><span className='g_m_left_50'><b>{next ? totals.nextGSTF4 : totals.totalGSTF4}</b></span></td>
        <td className='g_text_right'><span className='g_m_left_50'><b>{next ? totals.nextLateInterestF4 : totals.totalLateInterestF4}</b></span></td>
        <td className='g_text_right'><span className='g_m_left_50'><b>{next ? totals.nextDSRADipInterestF4 : totals.totalDSRADipInterestF4}</b></span></td>
        <td className='g_text_right'><span className='g_m_left_50'><b>{next ? totals.nextDefaultInterestF4 : totals.totalDefaultInterestF4}</b></span></td>
        <td className='g_text_right'><span className='g_m_left_50'><b>{next ? totals.nextPayableF4 : totals.totalPayableF4}</b></span></td>
        <td></td>
      </tr>
    </tbody></table>
  </div>


export default RepaymentListOldUI
